export default __webpack_public_path__ + "frontend/assets/helpdesk_cover2.webp";